import { HStack, Link, StackProps, Text, Tooltip } from "@chakra-ui/react";

import { SlackChannel } from "@reflag/shared/slackConnectionAPI";

import { SlackConnectionIcon } from "./SlackConnectionIcon";

export type SlackChannelDisplayProps = StackProps & {
  showIcon?: boolean;
  slackChannel?: SlackChannel;
  link?: boolean;
  showTooltip?: boolean;
};

export function SlackChannelDisplay({
  showIcon = true,
  slackChannel,
  link = false,
  showTooltip = false,
  ...stackProps
}: SlackChannelDisplayProps) {
  const content = (
    <>
      {showIcon && <SlackConnectionIcon isDisabled={!slackChannel} />}
      {slackChannel ? (
        <Tooltip
          isDisabled={!showTooltip}
          label={slackChannel.name}
          openDelay={300}
          hasArrow
        >
          <Text isTruncated>{slackChannel.name}</Text>
        </Tooltip>
      ) : (
        <Text color="dimmed" isTruncated>
          No channel
        </Text>
      )}
    </>
  );

  return (
    <HStack alignItems={"center"} width="full" isTruncated {...stackProps}>
      {link && slackChannel ? (
        <Link
          _hover={{ textDecoration: "underline" }}
          alignItems={"center"}
          display="inline-flex"
          gap={2}
          href={`https://slack.com/app_redirect?channel=${encodeURIComponent(
            slackChannel.id,
          )}`}
          target="_blank"
          textDecoration="none"
          isTruncated
        >
          {content}
        </Link>
      ) : (
        content
      )}
    </HStack>
  );
}
